/**
 * Display show notes and settlement notes
 */

import React from 'react';
import { Card, CardContent, Typography, Divider } from '@mui/material';

interface ShowNotesCardProps {
  notes?: string;
  settlementNotes?: string;
}

export const ShowNotesCard: React.FC<ShowNotesCardProps> = ({
  notes,
  settlementNotes,
}) => {
  if (!notes && !settlementNotes) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Notes
        </Typography>

        {notes && (
          <>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Show Notes
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: 'pre-wrap', mb: 2 }}
            >
              {notes}
            </Typography>
          </>
        )}

        {notes && settlementNotes && <Divider sx={{ my: 2 }} />}

        {settlementNotes && (
          <>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Settlement Notes
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {settlementNotes}
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
};
